import {Result} from '../../resultModel'
import {
    APPOINTMENTCOQUESTIONS_BY_ID_GETURL,
    APPOINTMENTCOQUESTIONS_SAVE_POSTURL,
} from '../../endpoints'
import {RequestManager} from '../../RequestManager'
import axios, { AxiosError } from 'axios'
import moment from 'moment'
import { AppointmentCOQuestionGroupDto, SaveAppointmentCOQuestionInput } from './models/saveAppointmentCOQuestionModels'
import { GetAppointmentCOQuestionOutput } from './models/getAppointmentCOQuestionModels'

export const getAppointmentCOQuestionsByAppointmentId = async (appointmentId: number) => {
  const requestManager = new RequestManager()

  var res: Result<AppointmentCOQuestionGroupDto> = {success: false, message: 'Hata', data: null}
  ////debugger
  return requestManager
    .get<Result<AppointmentCOQuestionGroupDto>>(APPOINTMENTCOQUESTIONS_BY_ID_GETURL(appointmentId))
    .then((response) => {
      ////debugger
      res = response
      return res
    })
    .catch((error) => {
      res.message = error.message
      return res
    })
}

  export const saveAppointmentCOQuestions = async (input: SaveAppointmentCOQuestionInput) => {
    const requestManager = new RequestManager()
  
    var res: Result<string> = {success: false, message: 'Hata', data: null}
    ////debugger
    return requestManager
      .post<Result<string>>(APPOINTMENTCOQUESTIONS_SAVE_POSTURL, input)
      .then((response) => {
        ////debugger
        res = response
        return res
      })
      .catch((error) => {
        res.message = error.message
        return res
      })
  }

//   export const getAppointmentQuestionExcelResult = async (appointmentId: number, type: number, appointmentDate: Date) => {
//     const res: Result<any> = {success: false, message: 'Hata', data: null}
  
//     try {
//       const response = await axios.get(APPOINTMENTQUESTIONS_EXCEL_RESULT_GETURL(appointmentId, type), {
//         responseType: 'arraybuffer', // Dosyayı binary olarak almak için gerekli
//       })
  
//       const blob = new Blob([response.data], {
//         type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       })
  
//       const fileName = type === 15001 ? 'HAPA_' : (type === 15002 ? 'FNBTTest' : 'WEMİOÖTest') + '_' + moment(appointmentDate).format('DD MMMM YYYY') + '.xlsx';
//       const url = window.URL.createObjectURL(blob)
//       const a = document.createElement('a')
//       a.href = url
//       a.download = fileName
//       a.click()
//       window.URL.revokeObjectURL(url)
  
//       res.success = true
//       return res
//     } catch (error) {
//       if (axios.isAxiosError(error)) {
//         const axiosError = error as AxiosError
//         console.error('Axios Hatası:', axiosError.message)
//       } else {
//         console.error('Bilinmeyen Hata:', error)
//       }
  
//       res.message = 'Bilinmeyen hata'
//       return res
//     }
//   }

